// import { MCSL_SCRIPT_REGEXP } from "./ConstantValues"
import { MCSL_SCRIPT_WITH_PRINT_REGEXP, MCSL_SCRIPT_REGEXP } from "./ConstantValues"

/**
 * 
 * @param {Array} messages_data // filtering messages
 * @param {Boolean}  includePrints // filter includes {%=%}  
 * */ 
export const mcsl_scriptFilter = (messages_data, includePrints=false) => {
  // const result = messages_data.match(MCSL_SCRIPT_REGEXP)
  let filtered_messages_data = ""
  const results = []

  let myArray
  while ((myArray = ( includePrints ? MCSL_SCRIPT_WITH_PRINT_REGEXP : MCSL_SCRIPT_REGEXP).exec(messages_data)) !== null) {
    // console.log('MCSL_SCRIPT_REGEXP.exec(messages_data) :', MCSL_SCRIPT_REGEXP.exec(messages_data));
    // console.log('myArray :', myArray);
    // console.log('messages_data.slice(0, myArray.index) + messages_data.slice(myArray.index+myArray[0].length) :', messages_data.slice(0, myArray.index) + messages_data.slice(myArray.index+myArray[0].length));
    // messages_data = messages_data.slice(0, myArray.index) + messages_data.slice(myArray.index+myArray[0].length)
    // console.log('messages_data updated :', messages_data);
    results.push(myArray)
  }
  let prev_last_index
  results.some((result, i, reuslts) => {
    const { index } = result
    const { length } = result[0]
    if (i === 0) {
      filtered_messages_data += messages_data.slice(0, index)
    } else {
      filtered_messages_data += messages_data.slice(prev_last_index, index)    
      if (i === results.length-1) { // last index
        filtered_messages_data += messages_data.slice(index+length, messages_data.length)
      }
    }
    
    prev_last_index = index + length

    // 결과가 하나밖에 없을 경우 나머지 문자열을 붙힘
    if (i === 0 && reuslts.length === 1) {
      filtered_messages_data += messages_data.slice(prev_last_index, messages_data.length)
    }
  })
  // if (result) {
  //   console.log('result.length :', result.length);
  //   const { index } = result
  //   messages_data = messages_data.slice(0, index) + messages_data.slice(index+result[0])
  //   console.log('response sliced result :', messages_data);
  //   return messages_data
  // }
  
  if (filtered_messages_data === "") {
    console.info("mcsl_scriptfilter가 실행되었지만 정규식에 탐지된 구문이 하나도 없음")
    // console.info("받은 messages_data를 그대로 반환합니다.")
    return null
    // return messages_data
  }
  return filtered_messages_data
}

export const mcsl_replace = (messages_data) => {
  messages_data = messages_data.replace(MCSL_SCRIPT_WITH_PRINT_REGEXP, "{%MCSL%}")
  // console.log('Replaced messages_data :', messages_data);
  return messages_data
}